import { FormStatus, IFormDocument } from "../types/client-forms.types";

export const DRAFT_SAVEABLE_STATUSES = [
    FormStatus.NOT_SENT,
    FormStatus.SENT,
    FormStatus.NEEDS_CORRECTION,
] as const;

export const isDraftSaveableStatus = (status: FormStatus): boolean =>
    DRAFT_SAVEABLE_STATUSES.some((draftStatus) => draftStatus === status);

export const getConsentAttachmentFiles = (documents: IFormDocument[]) =>
    documents.reduce(
        (filesByField, document) => {
            if (
                document.document_type !== "form_attachment" ||
                !document.field_id
            ) {
                return filesByField;
            }

            return {
                ...filesByField,
                [document.field_id]: [
                    ...(filesByField[document.field_id] ?? []),
                    document.document_name,
                ],
            };
        },
        {} as Record<string, string[]>
    );

const FORM_STATUS_DISPLAY = {
    [FormStatus.NOT_SENT]: "Not Sent",
    [FormStatus.SENT]: "Sent",
    [FormStatus.RECEIVED]: "Received",
    [FormStatus.CANCELLED]: "Cancelled",
    [FormStatus.PAUSED]: "Paused",
    [FormStatus.NEEDS_CORRECTION]: "Needs Correction",
    [FormStatus.COMPLETED]: "Completed",
    [FormStatus.RECEIVED_RENEWAL]: "Received Renewal",
    [FormStatus.RENEWAL_SENT]: "Renewal Sent",
    [FormStatus.NO_LONGER_NEEDED]: "No Longer Needed",
    [FormStatus.FOLLOW_UPS_COMPLETED]: "Follow Ups Completed",
    [FormStatus.NEEDS_RENEWAL]: "Needs Renewal",
};

const FORM_STATUS_BG = {
    [FormStatus.NOT_SENT]: "var(--color-danger-bg)",
    [FormStatus.SENT]: "var(--color-info-bg)",
    [FormStatus.CANCELLED]: "var(--color-danger-bg)",
    [FormStatus.PAUSED]: "var(--color-warning-bg)",
    [FormStatus.RECEIVED]: "var(--color-info-bg)",
    [FormStatus.RECEIVED_RENEWAL]: "var(--color-info-bg)",
    [FormStatus.RENEWAL_SENT]: "var(--color-info-bg)",
    [FormStatus.NO_LONGER_NEEDED]: "var(--color-info-bg)",
    [FormStatus.FOLLOW_UPS_COMPLETED]: "var(--color-info-bg)",
    [FormStatus.NEEDS_RENEWAL]: "var(--color-warning-bg)",
    [FormStatus.NEEDS_CORRECTION]: "var(--color-warning-bg)",
    [FormStatus.COMPLETED]: "var(--color-success-bg)",
};

const FORM_STATUS_TEXT: Partial<Record<FormStatus, string>> = {
    [FormStatus.NOT_SENT]: "var(--color-danger-text)",
    [FormStatus.SENT]: "var(--color-info-text)",
    [FormStatus.CANCELLED]: "var(--color-danger-text)",
    [FormStatus.PAUSED]: "var(--color-warning-text)",
    [FormStatus.RECEIVED]: "var(--color-info-text)",
    [FormStatus.RECEIVED_RENEWAL]: "var(--color-info-text)",
    [FormStatus.RENEWAL_SENT]: "var(--color-info-text)",
    [FormStatus.NO_LONGER_NEEDED]: "var(--color-info-text)",
    [FormStatus.FOLLOW_UPS_COMPLETED]: "var(--color-info-text)",
    [FormStatus.NEEDS_RENEWAL]: "var(--color-warning-text)",
    [FormStatus.NEEDS_CORRECTION]: "var(--color-warning-text)",
    [FormStatus.COMPLETED]: "var(--color-success-text)",
};

export const getStatusDisplay = (status: FormStatus) =>
    FORM_STATUS_DISPLAY[status as FormStatus] ?? status;

export const getStatusColors = (status: FormStatus) => ({
    bgColor: FORM_STATUS_BG[status as FormStatus] ?? "#f3f4f6",
    textColor: FORM_STATUS_TEXT[status] ?? "#1f2937",
});
